module.exports = {
	"de": {
		"translation": {
			"moreInformation": "weitere Informationen",
			"close": "Schließen",
			"uploader": {
				"overlay": {
					"title": "Ziehen und Ablegen",
					"subtitle": "Dateien hier"
				},
				"form": {
					"dragAndDrop": "Ziehen und Ablegen",
					"or": "oder",
					"chooseFiles": "Dateien auswählen",
					"from": "Von Ihrem Rechner"
				},
				"errors": {
					"file_size": "überschreitet die maximale Dateigröße von {{size}}.",
					"file_type": "{{type}} ist nicht der richtige Dateityp."
				},
				"status": {
					"idle": "Inaktiv",
					"processing": "In Bearbeitung...",
					"uploading": "Wird hochgeladen",
					"success": "Erfolg",
					"cancel": "Abbrechen",
					"error": "Fehler",
					"none": ""
				}
			},
			"actions": {
				"delete": "Löschen",
				"apply": "Anwenden",
				"cancel": "Abbrechen"
			},
			"dateInput": {
				"choose": "Datum auswählen",
				"clear": "Datum löschen"
			},
			"daterange": {
				"last_7_days": "Letzte 7 Tage",
				"last_30_days": "Letzte 30 Tage",
				"this_month": "Diesen Monat",
				"last_month": "Letzten Monat",
				"start_date": "Startdatum",
				"end_date": "Enddatum",
				"not_set": "Nicht festgelegt"
			},
			"comment": {
				"delete": "Anmerkung löschen"
			},
			"pagination": {
				"intro": "Seitennummerierung, aktuell auf Seite {{currentPage}}",
				"page": "Seite {{pageNumber}}",
				"ellipsis": "Weitere Seiten",
				"prev": "Vorherige Seite",
				"next": "Nächste Seite"
			},
			"formElement": {
				"optional": "(optional)",
				"required": "(erforderlich)"
			},
			"prevNextArrowButton": {
				"arrowup": "Auf",
				"arrowdown": "Ab",
				"escape": "Escape"
			},
			"externalLink": {
				"view": "anzeigen"
			},
			"collapsible": {
				"ariaText": "ausblendbarer Bereich"
			}
		}
	}
};